import script from "./ProssimaSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProssimaSection.vue?vue&type=script&setup=true&lang=ts"

import "./ProssimaSection.vue?vue&type=style&index=0&id=d05690c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d05690c6"]])

export default __exports__